import { Container, Heading } from "@chakra-ui/react";
import { getLayout } from "components/Layout";
import PageSection from "components/Layout/PageSection";
import HeadTitle from "components/Shared/HeadTitle";
import UserProfileForm from "components/Core/AccountInfo/UserProfileForm";

export default function UserProfileIndex() {
  return (
    <PageSection paddingTop="3rem">
      <HeadTitle title="User Profile" />
      <Container ml={0}>
        <Heading as="h1" variant="section-header" marginBottom=".75em">
          User Profile
        </Heading>

        <UserProfileForm />
      </Container>
    </PageSection>
  );
}

UserProfileIndex.getLayout = getLayout;
